import { render, staticRenderFns } from "./UnionPayDesc.vue?vue&type=template&id=0be09de5&scoped=true&"
var script = {}
import style0 from "./UnionPayDesc.vue?vue&type=style&index=0&id=0be09de5&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0be09de5",
  null
  
)

export default component.exports